import { useContext, useEffect } from 'react'
import { CheckBox } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import GroupCheckIcon from '@nv/images/design/group-check-icon'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const AcceptNominationModal = ({ confirm, title }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: { consent: false },
    validationSchema: Yup.object({ consent: Yup.boolean().oneOf([true], t('You must agree to the terms')) }),
    onSubmit: () => confirm(),
  })

  useEffect(() => {
    setHeaderLabel(t('Accept Nomination'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, isCancel: true },
      { text: t('buttons.confirm'), onClick: formik.handleSubmit },
    ])
  }, [])

  return (
    <>
      <GroupCheckIcon />
      <span>{t(`Youre accepting a nomination for ${title}.`)}</span>
      <div>
        <CheckBox
          checked={formik.values.consent}
          onChange={() => formik.setFieldValue('consent', !formik.values.consent)}
          formik={formik}
          field='consent'
          label={t(
            'By selecting this option, I confirm that I have read and agree to the Terms and Conditions, and I accept all the stated terms. I understand that withdrawing my candidacy is final and cannot be undone.',
          )}
        />
      </div>
    </>
  )
}
